const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {    
        dataField: 'categoryName',
        text: 'Name',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {    
        dataField: 'categoryDescription',
        text: 'Description',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {       
        dataField: 'categoryTypeName',
        text: 'Type',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    }
];
    
export const sorting = [{
    dataField: 'createdOn',
    order: 'desc'
}];